import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Costanti } from '../costanti';

@Injectable()
export class ContenutiService {
  private BASEURL = Costanti.APIURL + 'contenuti/';

  protected loadingSubject = new BehaviorSubject(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(private http: HttpClient) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  private extractData(res) {
    return res['data'] || {};
  }

  getModusOperandi() {
    this.loadingSubject.next(true);
    const body = {};
    const url = this.BASEURL + 'modus-operandi';
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  getContenutoDinamico(codice: string) {
    this.loadingSubject.next(true);
    const body = { codice };
    const url = this.BASEURL + 'get-contenuto-dinamico';
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  getContenutoDinamicoT() {
    this.loadingSubject.next(true);
    const body = {};
    const url = this.BASEURL + 'get-contenuto-dinamico-t';
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
}
